// extracted by mini-css-extract-plugin
export var option = "_a1-0";
export var optionCard = "_a1-f";
export var optionContent = "_a1-g";
export var optionIcon = "_a1-i";
export var optionIconBox = "_a1-h";
export var optionLabel = "_a1-j";
export var optionPill = "_a1-m";
export var optionPillBadge = "_a1-p";
export var optionPillIcon = "_a1-n";
export var optionPillLabel = "_a1-o";
export var optionRadio = "_a1-k";
export var optionRadioInner = "_a1-l";
export var optionReveal = "_a1-2";
export var optionRevealDelay0 = "_a1-3";
export var optionRevealDelay1 = "_a1-4";
export var optionRevealDelay10 = "_a1-d";
export var optionRevealDelay11 = "_a1-e";
export var optionRevealDelay2 = "_a1-5";
export var optionRevealDelay3 = "_a1-6";
export var optionRevealDelay4 = "_a1-7";
export var optionRevealDelay5 = "_a1-8";
export var optionRevealDelay6 = "_a1-9";
export var optionRevealDelay7 = "_a1-a";
export var optionRevealDelay8 = "_a1-b";
export var optionRevealDelay9 = "_a1-c";
export var optionSelected = "_a1-1";